import React from 'react';

import FitmentResults from '../../../../components/fitment/components/fitment-results/fitment-results';

import { Fitment } from '../../../../shared/types/fitment';

import './vehicle-landing-page-shop-other.scss';

interface VehicleLandingPageShopOtherProps {
  category: string;
  fitment: Fitment;
}

function VehicleLandingPageShopOther(props: VehicleLandingPageShopOtherProps) {
  const { category, fitment } = props;

  return (
    <div styleName="results">
      <FitmentResults
        fitment={fitment}
        headerText="Shopping for something else?"
        hideNeedAssistance
        searchTypeToHide={category}
        shouldDisplayShopTiresModal
      />
    </div>
  );
}

export default VehicleLandingPageShopOther;
